"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/ACFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_2)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_2`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24.8842 12.7088C24.8772 15.4596 24.4351 18.4211 20.8561 19.8316C17.2702 18.4211 16.8351 15.4596 16.8281 12.7088H24.8842Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24.8491 13.8737C24.6526 16.3228 23.9789 18.6035 20.8491 19.8386C17.7333 18.6035 17.0246 16.2456 16.8561 13.8807",
					fill: "#29DBFF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24.7228 15.0246C24.4983 16.7298 23.5509 18.779 20.8562 19.8386C18.1614 18.779 17.3123 16.8561 16.9895 15.0386",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M24.4702 16.1614C24.0702 17.4035 23.1158 18.9263 20.8702 19.8667C18.6246 18.9825 17.6983 17.4947 17.2632 16.1474",
					fill: "#29DBFF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M23.9439 17.3263C23.4877 18.1193 22.7018 19.1088 20.8562 19.8456C18.9263 19.0386 18.2316 18.0702 17.7684 17.3123",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M22.9403 18.6035C22.3719 19.1088 22.0982 19.3895 20.8631 19.8597C19.4526 19.3053 19.2772 19.0456 18.814 18.6316",
					fill: "#29DBFF"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.8982 16.2526C20.8842 16.2386 18.9404 18.7579 18.9404 18.7579C18.814 18.6667 18.2386 18.0912 18.007 17.7053L20.9053 14.1895L23.7263 17.6772C23.4526 18.1333 22.9263 18.6316 22.8 18.7298M20.8491 5.98596L18.9895 9.14386H22.7088L20.8491 5.98596Z",
					fill: "#5CC85C"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.5438 15.9875C15.7967 14.1171 15.5129 12.5347 14.9099 12.4532C14.3069 12.3716 13.6131 13.8218 13.3602 15.6923C13.1073 17.5627 13.3911 19.1451 13.9941 19.2266C14.5971 19.3082 15.2909 17.858 15.5438 15.9875Z",
					fill: "#F7A226"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.7404 11.7442C15.9095 11.3235 15.8367 10.898 15.5778 10.7939C15.3189 10.6898 14.9719 10.9465 14.8028 11.3673C14.6336 11.788 14.7064 12.2134 14.9653 12.3175C15.2242 12.4216 15.5712 12.1649 15.7404 11.7442Z",
					fill: "#DDC7AB"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.6994 19.0996C14.7629 18.6623 14.7118 18.293 14.5852 18.2746C14.4586 18.2562 14.3045 18.5958 14.2411 19.033C14.1776 19.4703 14.2287 19.8396 14.3553 19.858C14.4818 19.8764 14.6359 19.5368 14.6994 19.0996Z",
					fill: "#DDC7AB"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.0665 19.6768C15.1942 19.6699 15.2793 19.3192 15.2565 18.8935C15.2336 18.4678 15.1116 18.1282 14.9839 18.1351C14.8562 18.1419 14.7711 18.4926 14.7939 18.9183C14.8168 19.344 14.9388 19.6836 15.0665 19.6768Z",
					fill: "#DDC7AB"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.4241 15.0075C16.5719 14.9492 16.5338 14.5015 16.3391 14.0076C16.1443 13.5136 15.8666 13.1604 15.7188 13.2187C15.5709 13.277 15.609 13.7247 15.8037 14.2186C15.9985 14.7126 16.2762 15.0658 16.4241 15.0075Z",
					fill: "#DDC7AB"
				}),
				/* @__PURE__ */ n("path", {
					d: "M16.3869 12.7661C16.8809 12.5713 17.234 12.2936 17.1758 12.1458C17.1175 11.9979 16.6698 12.036 16.1758 12.2307C15.6819 12.4255 15.3287 12.7032 15.387 12.851C15.4453 12.9989 15.8929 12.9608 16.3869 12.7661Z",
					fill: "#DDC7AB"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.1965 9.14386L18.9895 10.8772L20.2386 12.7088H21.7895L22.1193 10.9263L21.7404 9.14386H20.1965Z",
					fill: "#B0C6CC"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 0V8.2386H8.72982L11.9649 10.393V11.9789H10.3789L5.22807 8.54737V11.9789H0.736842V8.54737L-4.41404 11.9789H-6V10.393L-2.76491 8.2386H-6V3.74737H-2.76491L-6 1.59298V0H-4.41404L0.736842 3.43158V0H5.22807V3.43158L10.3789 0H11.9649Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.10526 0H1.85965V4.87018H-6V7.11579H1.85965V11.9789H4.10526V7.11579H11.9649V4.87018H4.10526V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 1.59299V3.74737H8.7298L11.9649 1.59299Z",
					fill: "#2E52B2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 11.9789V11.207L-1.61404 8.2386H-0.0280704L-5.48772 11.9789H-6ZM-5.48772 0.00701904L-0.0280704 3.74035H-1.61404L-6 0.778949V0.00701904H-5.48772ZM11.9649 0.00701904V0.778949L7.57895 3.74737H5.99298L11.4526 0.00701904H11.9649ZM11.4526 11.9789L5.99298 8.2386H7.57895L11.9649 11.207V11.9789H11.4526Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_2`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as ACFlag };
